import React from "react";
import {NavLink} from "react-router-dom";
import "../Navbar.css";
import LanguageSelector from "../LanguageSelector";
import useTranslation from "../../../i18n/useTranslation";
import {GlobalStyles} from "../../../constants/styles";
import BrandName from "../BrandName";

const TopBar = ({imgPath}) => {
    const {t} = useTranslation();
    return (
        <nav
            className="public-topbar w-100"
            style={{
                "--topbar-accent": GlobalStyles.colors.brandBlue,
                "--topbar-orange": GlobalStyles.colors.brandOrange
            }}
        >
            <div className="container-fluid public-topbar__container">
                <div className="public-topbar__main">
                    <NavLink to="/" className="topbar-brand-link text-decoration-none">
                        <span className="topbar-logo-frame">
                            <img
                                src={imgPath}
                                alt="AngeonX Sports"
                                className="topbar-logo logo img-fluid logo-on-brand-blue"
                            />
                        </span>
                        <BrandName className="brand-text" size="1.55rem" sportsStyle={{fontStyle: "italic", marginLeft: 4}} />
                    </NavLink>

                    <div className="topbar-message">
                        <p className="tagline m-0">{t('topBar.passion')}</p>
                        <p className="sub-tagline m-0">{t('topBar.powerAi')}</p>
                        <p className="motto m-0">{t('topBar.ourTech')}</p>
                    </div>

                    <div className="topbar-actions">
                        <div className="topbar-language">
                            <LanguageSelector variant="desktop"/>
                        </div>
                        <div className="topbar-auth">
                            <NavLink to="/login" className="topbar-login">
                                {t('auth.loginTitle')}
                            </NavLink>
                            <NavLink to="/register" className="topbar-register">
                                {t('auth.registerTitle')}
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default TopBar;
